import { useRouter } from 'next/navigation';
import { Button } from 'src/uikit/Button';

import s from './SubscribeAd.module.scss';

export function SubscribeAd({ onClose }: { onClose: () => void }) {
  const { push } = useRouter();

  return (
    <div className={s.root}>
      <img
        src="/svg/pages/warp/article/close-icon.svg"
        className={s.close}
        onClick={onClose}
        alt="Close icon"
        width="24"
        height="24"
        data-qa="article-subscribe-close"
      />
      <h3 className={s.title} data-qa="article-subscribe-title">
        Подписка на&nbsp;дайджест
      </h3>
      <p className={s.text} data-qa="article-subscribe-description">
        Один раз в месяц присылаем новости сервисов и платформ, кейсы и анонсы
        мероприятий
      </p>
      <Button
        variant={Button.variants.Primary}
        className="gtm-click-subscribe-ad"
        onClick={() => push('/subscription')}
        data-qa="article-subscribe-btn"
        analyticsOptions={{
          action: 'click',
          clickZone: 'body',
          clickElement: 'button',
          clickContent: 'Подписаться',
          uniqueId: 'article-subscribe-button',
          transitionType: 'inside-link',
        }}
      >
        Подписаться
      </Button>
    </div>
  );
}
